'use client';

import { useEffect } from 'react';

import { useCurrentApp } from 'hooks/use-current-app';
import { useSnapshot } from 'hooks/use-safe-snapshot';
import { CurrentAppService } from 'services/CurrentAppService';
import { state as currentUserState } from 'state/current-user';

// App router pages never load the user into currentUserState,
// so they can't tell an anonymous visitor from a signed-in one
const CurrentAppTracking = ({ userLoaded = true }: { userLoaded?: boolean }) => {
    const currentApp = useCurrentApp();
    const { user } = useSnapshot(currentUserState);

    // remember the current app for next page
    // eg. so we show RE+ nav on /products for users coming from RE+
    useEffect(() => {
        CurrentAppService.setActive(currentApp, userLoaded ? (user?.id ?? null) : undefined);
    }, [currentApp, user?.id, userLoaded]);

    return null;
};

export { CurrentAppTracking };
